import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import IdsData from "./ids_data/IdsData";
import CampaignGroups from "../CampaignGroups";
import Goals from "./goals/Goals";
import Dashboard from "./dashboard/Dashboard";
import Scripts from "./scripts/Scripts";
import Alerts from "./alerts/Alerts";
import updateParams from "utils/updateParams.js";
import jsDig from "utils/jsDig"

export default function Display(props) {
	const [tabLocation, setTabLocation] = useState("");

	useEffect(() => {
		let searchParams = new URL(location.href).searchParams;
		let page = searchParams.get("subpage");
		if (!page || page == "") {
			page = "ids_data";
		}
		setTabLocation(page);
		updateParams("subpage", page);
	}, []);

	const selectTab = (key) => {
		setTabLocation(key);
		updateParams("subpage", key);
	};


	// const [shouldWeReloadDisplay, setShouldWeReloadDisplay ]= useState(props.search_section.data_pull_status.display_data_pull !== true)
  // useEffect(() => {
  //   if (props.search_section.data_pull_status.display_data_pull === true) {
  //     setTimeout(() => {setShouldWeReloadDisplay(shouldWeReloadDisplay)}, 3000)
  //   }
  // }, [shouldWeReloadDisplay])

	const campaignGroups = props.display_section.campaign_groups
	const google_ads_id = [jsDig(["google_ads", "account_ids"], props.search_section.platform_data), jsDig(["google_ads", "account_ids"], props.display_section.platform_data), jsDig(["google_ads", "account_ids"], props.video_section.platform_data)].filter((id) => id != null)[0]
	const show_scripts = google_ads_id && google_ads_id != "" && !props.search_section.enabled && props.display_section.enabled

	return (
		<>
			<div className="px-md-5 px-0 pb-5 pt-0 ppc-config-display">
				{props.selectedPage == "display" && (
					<input hidden name="selected_subpage" value={tabLocation} readOnly />
				)}
				<Tab.Container
					id="ppc-display-subtabs"
					defaultActiveKey="ids_data"
					activeKey={tabLocation}
					onSelect={(k) => selectTab(k)}
				>
					<Nav variant="pills" className={`mt-4 pb-0 nav-fill tabs-navigation-3 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-${show_scripts ? 6 : 5}`}>
						<Nav.Item className="col">
							<Nav.Link eventKey="ids_data" data-link-type="subpage">IDs and Data</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="campaign_groups" data-link-type="subpage">Campaign Groups</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="goals" data-link-type="subpage">Goals</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="dashboard" data-link-type="subpage">Dashboard</Nav.Link>
						</Nav.Item>
						{show_scripts &&
							<Nav.Item className="col">
								<Nav.Link eventKey="scripts" data-link-type="subpage">Scripts</Nav.Link>
							</Nav.Item>
						}
						<Nav.Item className="col">
							<Nav.Link eventKey="alerts" data-link-type="subpage">Alerts</Nav.Link>
						</Nav.Item>
					</Nav>
					<Tab.Content className="pl-md-0">
						<Tab.Pane eventKey="ids_data">
							<IdsData {...props} />
						</Tab.Pane>
						<Tab.Pane eventKey="campaign_groups">
							<CampaignGroups {...props} platformType="Display" campaignGroups={campaignGroups}/>
						</Tab.Pane>
						<Tab.Pane eventKey="goals">
							<Goals {...props} campaignGroups={[]} />
						</Tab.Pane>
						<Tab.Pane eventKey="dashboard">
							<Dashboard {...props} />
						</Tab.Pane>
						{show_scripts &&
							<Tab.Pane eventKey="scripts">
								<Scripts {...props} />
							</Tab.Pane>
						}
						<Tab.Pane eventKey="alerts">
							<Alerts {...props} />
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			</div>
		</>
	);
}
